import React from 'react';
import { Eye } from 'lucide-react';
import './ButtonView.css';

const ButtonView = ({ onClick, disabled = false, children = 'Ver detalle' }) => {
  return (
    <button className="boton-ver" onClick={onClick} disabled={disabled} title="Ver detalle">
      <Eye />
      <span>{children}</span>
    </button>
  );
};

export default ButtonView;
